import axios from 'axios'
import appConfig from '@/appconfig'

export const state = {
  cached: [],
  lenderId: getSavedLenderState('lenders.lenderId'),
}

export const getters = {
  lenderId: (state) => {
    return state.lenderId
  },
  lenderDetails: (state) => {
    return state.lenderDetails
  },
}

export const mutations = {
  CACHE_LENDER(state, selectedLender) {
    state.cached.push(selectedLender)
  },
  SET_LENDERS(state, lenders) {
    state.lenders = lenders
    saveLenderState('lenders.lenderId', null)
  },
  SET_LENDER_ID(state, lenderId) {
    state.lenderId = lenderId
    saveLenderState('lenders.lenderId', lenderId)
  },
  SET_LENDER_DETAILS(state, lenderDetails) {
    state.lenderDetails = lenderDetails
  },
}

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  storeLender({ commit }, { lenderId } = {}) {
    commit('SET_LENDER_ID', lenderId)
  },

  fetchCreditAgencies({ commit }) {
    return axios
      .get(`${appConfig.adminApiUri}master/getcreditreportingagencies`, headers)
      .then((response) => {
        return response.data
      })
    // .catch(function(error) {
    //   // alert(error)
    // })
  },

  fetchNotificationPreferences({ commit }) {
    return axios
      .get(
        `${appConfig.adminApiUri}master/getLenderNotificationPreferences`,
        headers
      )
      .then(function(response) {
        return response.data
      })
    // .catch(function (error) {
    //   // alert(error)
    // })
  },

  fetchLenders(
    { commit },
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.adminApiUri}lender/getlenders/?PageSize=${pageSize}&PageNumber=${pageNumber}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        headers
      )
      .then((response) => {
        const lenders = response.data
        commit('SET_LENDERS', lenders)
        return lenders
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          commit('SET_LENDERS', null)
        }
        return null
      })
  },

  fetchTotalLenders(
    { commit },
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.adminApiUri}lender/getlenderstotalrecords?PageSize=${pageSize}&PageNumber=${pageNumber}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        headers
      )
      .then((response) => {
        const totalLenders = response.data
        return totalLenders
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
        }
        return null
      })
  },
  fetchLenderById({ commit }, { lenderId } = {}) {
    return axios
      .get(`${appConfig.adminApiUri}lender/getlenderbyid/` + lenderId, headers)
      .then((response) => {
        commit('SET_LENDER_DETAILS', response.data)

        return response.data
      })
    // .catch(function (error) {
    //   // alert(error)
    // })
  },

  uploadLenderImage({ commit }, { file }) {
    var formData = new FormData()
    formData.append('image', file, 'image.jpg')
    return axios
      .post(appConfig.adminApiUri + 'lender/uploadlogo/', formData, {
        headers: headers,
      })
      .then((response) => {
        return response
      })
    // .catch(function (error) {
    //   // alert(error)
    // })
  },

  saveLender(
    { getter },
    {
      lenderName,
      lenderWebsite,
      logoURL,
      logoPath,
      originalFileName,
      isActive,
      createdByUserId,
      generalEmailAddress,
      notificationPreferenceID,
      lenderCreditAgencies,
    } = {}
  ) {
    var createNewLenderData = new FormData()
    createNewLenderData.append('LenderName', lenderName)
    createNewLenderData.append('LenderWebsite', lenderWebsite)
    createNewLenderData.append('LogoUrl', logoURL)
    createNewLenderData.append('Logo[LogoPath]', logoPath)
    createNewLenderData.append('Logo[OriginalFileName]', originalFileName)
    createNewLenderData.append('IsActive', isActive)
    createNewLenderData.append('CreatedByUserId', createdByUserId)
    createNewLenderData.append('GeneralEmailAddress', generalEmailAddress)
    createNewLenderData.append(
      'NotificationPreferenceID',
      notificationPreferenceID
    )

    for (let i = 0; i < lenderCreditAgencies.length; i++) {
      createNewLenderData.append(
        'LenderCreditAgencies[' + i + '][LenderCreditAgencyID]',
        lenderCreditAgencies[i].LenderCreditAgencyID
      )
      createNewLenderData.append(
        'LenderCreditAgencies[' + i + '][CreditAgency]',
        lenderCreditAgencies[i].CreditAgency
      )
      createNewLenderData.append(
        'LenderCreditAgencies[' + i + '][CreditAgencyID]',
        lenderCreditAgencies[i].CreditAgencyID
      )
    }

    return axios
      .post(
        `${appConfig.adminApiUri}lender/create/`,
        createNewLenderData,
        headers
      )
      .then((response) => {
        return response
      })
    // .catch(function (error) {
    //   // alert(error)
    // })
  },
  updateLender(
    { getter },
    {
      lenderId,
      lenderName,
      lenderWebsite,
      logoURL,
      logoPath,
      originalFileName,
      isActive,
      createdByUserId,
      generalEmailAddress,
      notificationPreferenceID,
      creditAgencies,
      lenderExternalId,
    } = {}
  ) {
    var updateLenderData = new FormData()
    updateLenderData.append('LenderID', lenderId)
    updateLenderData.append('LenderName', lenderName)
    updateLenderData.append('LenderWebsite', lenderWebsite)
    updateLenderData.append('LogoUrl', logoURL)
    updateLenderData.append('Logo[LogoPath]', logoPath)
    updateLenderData.append('Logo[OriginalFileName]', originalFileName)
    updateLenderData.append('IsActive', isActive)
    updateLenderData.append('CreatedByUserId', createdByUserId)
    updateLenderData.append('GeneralEmailAddress', generalEmailAddress)
    updateLenderData.append('ExternalID', lenderExternalId)
    updateLenderData.append(
      'NotificationPreferenceID',
      notificationPreferenceID
    )

    for (let i = 0; i < creditAgencies.length; i++) {
      updateLenderData.append(
        'LenderCreditAgencies[' + i + '][LenderCreditAgencyID]',
        creditAgencies[i].LenderCreditAgencyID
      )
      updateLenderData.append(
        'LenderCreditAgencies[' + i + '][CreditAgency]',
        creditAgencies[i].CreditAgency
      )
      updateLenderData.append(
        'LenderCreditAgencies[' + i + '][CreditAgencyID]',
        creditAgencies[i].CreditAgencyID
      )
    }

    return axios
      .post(`${appConfig.adminApiUri}lender/update/`, updateLenderData, headers)
      .then((response) => {
        return response
      })
    // .catch(function (error) {
    //   // alert(error)
    // })
  },

  downloadlenderReport({ commit }, { pageSize, pageNumber, key, value }) {
    return axios
      .get(
        `${appConfig.adminApiUri}lender/download/?Pagesize=${pageSize}&PageNumber=${pageNumber}&key=${key}&value=${value}`,
        headers
      )
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = '\r\n' + response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'lenderReport.csv')
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'lenderReport.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
    // .catch(function (error) {
    //   // console.log(error)
    // })
  },
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}

function getSavedLenderState(key) {
  if (window.localStorage['lenders'] !== 'undefined')
    return JSON.parse(window.localStorage.getItem(key))
  else return null
}

function saveLenderState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

const headers = {
  'Accept-Version': 1,
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json; charset=utf-8',
}
